import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "logo-view" }
const _hoisted_2 = { class: "container-login" }
const _hoisted_3 = { class: "label-view" }
const _hoisted_4 = { class: "label-view" }
const _hoisted_5 = { class: "input-view" }
const _hoisted_6 = { class: "dont-account" }

import { defineComponent, computed, ref } from "vue";
import {
  IonContent,
  IonItem,
  IonPage,
  IonInput,
  IonLabel,
  IonImg,
  IonIcon,
  IonButton,
  IonSpinner,
  IonText,
  onIonViewWillLeave,
} from "@ionic/vue";
import {
  mailOutline,
  closeCircle,
  lockClosedOutline,
  eyeOffOutline,
  eyeOutline,
  logoGoogle,
  logoApple,
  logoFacebook,
} from "ionicons/icons";
import { useRouter } from "vue-router";
import useValidate from "@vuelidate/core";
import { required, email as emailType, minLength } from "@vuelidate/validators";
// import { useUserStore } from "@/store/modules/user";
import { useUserStore } from "@/store/modules/user";
import { presentToastWithOptions } from "@/utils/functions";

import { TextFieldTypes } from "@ionic/core";
import {
  SignInWithApple,
  SignInWithAppleResponse,
  SignInWithAppleOptions,
} from "@capacitor-community/apple-sign-in";
import {
  FacebookLogin,
  FacebookLoginResponse,
} from "@capacitor-community/facebook-login";

type AppleLoginResponse = {
  success: boolean;
  isNewUser?: boolean;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLogin',
  setup(__props) {

const userStore = useUserStore();
const router = useRouter();
const isLoading = computed(() => userStore.isLoading);
const email = ref("");
const password = ref("");
const remember = ref(false);
const passwordType = ref<TextFieldTypes>("password");
const confirmPasswordType = ref<TextFieldTypes>("password");
const FACEBOOK_PERMISSIONS = ["email", "public_profile"];
const passwordIcon = computed(() =>
  passwordType.value === "password" ? eyeOutline : eyeOffOutline
);
const confirmPasswordIcon = computed(() =>
  confirmPasswordType.value === "password" ? eyeOutline : eyeOffOutline
);
const changePasswordType = () =>
  (passwordType.value =
    passwordType.value === "password" ? "text" : "password");
const changeConfirmPasswordType = () =>
  (confirmPasswordType.value =
    confirmPasswordType.value === "password" ? "text" : "password");

const rules = computed(() => {
  return {
    email: { required, emailType },
    password: { required, minLength: minLength(6) },
  };
});
const v$ = useValidate(rules, { email, password });

onIonViewWillLeave(() => {
  email.value = "";
  password.value = "";
});

const login = async () => {
  v$.value.$validate();
  if (!v$.value.$error) {
    const result = await userStore.axLoginUser(email.value, password.value);
    if (result) router.push("/tabs/home");
    else presentToastWithOptions("Login Failed. Please Try Again.", "danger");
  }
};

// const googleLogin = async() => {
//   console.log("=== google login ===")
//   const res = await userStore.axGoogleLogin();
//   if (res) router.push("/tabs/home");
//   else presentToastWithOptions("Login failed!");
// }
const googleLogin = async () => {
  console.log("=== google login ===");
  const res = await userStore.axGoogleLogin();

  if (res.success) {
    if (res.isNewUser) {
      await router.push("/profile/create/addphoto");
    } else {
      await router.push("/tabs/home");
    }
  } else {
    await presentToastWithOptions("Login failed!");
  }
};

function generateNonce(length = 32) {
  const charset =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let result = "";
  const values = window.crypto.getRandomValues(new Uint32Array(length));
  for (let i = 0; i < length; i++) {
    result += charset[values[i] % charset.length];
  }
  return result;
}

async function sha256(str: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
const appleLogin = async () => {
  const rawNonce = generateNonce();
  const hashedNonce = await sha256(rawNonce);
  let options: SignInWithAppleOptions = {
    clientId: "com.beautysku.signin",
    redirectURI: `${process.env.VUE_APP_SOCIAL_AUTH_DOMAIN}/login`,
    scopes: "email name",
    state: "12345",
    nonce: hashedNonce,
  };
  SignInWithApple.authorize(options)
    .then(async (result: SignInWithAppleResponse) => {
      const { identityToken, authorizationCode, givenName, familyName } =
        result.response;

      if (!identityToken) {
        throw new Error("Missing identityToken from Apple");
      }
      console.log(result);

      // If you used a nonce, replace "nonce" with it
      const res = (await userStore.axAppleLogin(
        identityToken,
        rawNonce,
        givenName,
        familyName
      )) as AppleLoginResponse;
      console.log("Before if result: ", res, res.success);
      if (res.success) {
        console.log("In success", res.isNewUser);
        try {
          if (res.isNewUser) {
            await router.push("/profile/create/addphoto");
            console.log("Should be on addphoto screen now");
          } else {
            await router.push("/tabs/home");
            console.log("Should be on HOME screen now");
          }
        } catch (e) {
          console.error("Routing error:", e);
        }
      }
      console.log("SignInWIthApple");
    })
    .catch((error) => {
      // Handle error
      console.log(error);
    });
};
const fbLogin = async () => {
  await FacebookLogin.initialize({ appId: "1210908203870825" });

  const result = (await FacebookLogin.login({
    permissions: FACEBOOK_PERMISSIONS,
  })) as FacebookLoginResponse;

  if (result.accessToken) {
    const token = result.accessToken.token;
    console.log(`Facebook access token is ${token}`);

    // Pass the token to the store instead of the user
    const res: any = await userStore.axFbLogin(token);

    if (res.success) {
      console.log("Res", res);
      if (res?.isNewUser) {
        console.log("Navigating to /profile/create/addphoto");
        await router.push("/profile/create/addphoto");
      } else {
        await router.push("/tabs/home");
      }
    } else {
      await presentToastWithOptions("Login failed!", "danger");
    }
  } else {
    console.warn("Facebook login failed or was cancelled");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "signIn-wrapper" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonImg), {
              class: "logo-img",
              src: require('@/assets/images/logo_multismall.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(mailOutline),
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), {
                    class: "label-style",
                    position: "stacked"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Email ")
                    ])),
                    _: 1,
                    __: [7]
                  })
                ]),
                _createVNode(_unref(IonInput), {
                  modelValue: email.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  placeholder: "example@gmail.com"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_unref(v$).email.$error)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(v$).email.$errors, (error, idx) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "error-message",
                    key: idx.toString(),
                    style: {"color":"red"}
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonItem), { style: {"margin-top":"25px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(lockClosedOutline),
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), {
                    class: "label-style",
                    position: "stacked"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Password ")
                    ])),
                    _: 1,
                    __: [8]
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(IonInput), {
                    type: passwordType.value,
                    modelValue: password.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                    placeholder: 'Type your password'
                  }, null, 8, ["type", "modelValue"]),
                  _createVNode(_unref(IonIcon), {
                    icon: passwordIcon.value,
                    onClick: changePasswordType,
                    color: "black"
                  }, null, 8, ["icon"])
                ])
              ]),
              _: 1
            }),
            (_unref(v$).password.$error)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(v$).password.$errors, (error, idx) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "error-message",
                    key: idx.toString()
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              slot: "end",
              class: "forget-style",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/forgot-password/email')))
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("span", null, " Forgot Password?", -1)
            ])),
            _createVNode(_unref(IonButton), {
              style: {"height":"50px"},
              class: "login-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (login())),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    (isLoading.value)
                      ? (_openBlock(), _createBlock(_unref(IonSpinner), { key: 0 }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IonText), null, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode(" Login")
                      ])),
                      _: 1,
                      __: [10]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _cache[14] || (_cache[14] = _createElementVNode("p", {
              class: "or-style",
              style: {"padding-bottom":"20px","padding-top":"20px","color":"blueviolet"}
            }, " Or login with ", -1)),
            _createVNode(_unref(IonButton), {
              style: {"height":"50px"},
              class: "google-login-btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (googleLogin())),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                (isLoading.value)
                  ? (_openBlock(), _createBlock(_unref(IonSpinner), { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonIcon), {
                  slot: "start",
                  icon: _unref(logoGoogle)
                }, null, 8, ["icon"]),
                _cache[11] || (_cache[11] = _createTextVNode(" Google Login "))
              ]),
              _: 1,
              __: [11]
            }, 8, ["disabled"]),
            _createVNode(_unref(IonButton), {
              style: {"height":"50px"},
              class: "google-login-btn",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (appleLogin())),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                (isLoading.value)
                  ? (_openBlock(), _createBlock(_unref(IonSpinner), { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonIcon), {
                  slot: "start",
                  icon: _unref(logoApple)
                }, null, 8, ["icon"]),
                _cache[12] || (_cache[12] = _createTextVNode(" Apple Login "))
              ]),
              _: 1,
              __: [12]
            }, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_6, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-16-300" }, "Don't have an account?", -1)),
              _createElementVNode("a", {
                class: "text-16-700",
                onClick: _cache[6] || (_cache[6] = () => _unref(router).push('/signup'))
              }, " Register ")
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})